import { FeatureFlags } from 'models';

type FlagHolder = { flags?: readonly string[] | null } | null | undefined;

type ProjectHolder = { teamFlags?: readonly string[] | null } | null | undefined;

const FeatureFlagHelpers = {
    isEnabled: (flag: FeatureFlags, { user, team }: { user: FlagHolder; team: FlagHolder }) =>
        [user, team].some((holder) => holder?.flags?.includes(flag) ?? false),

    isEnabledForProject: (flag: FeatureFlags, { user, project }: { user: FlagHolder; project: ProjectHolder }) =>
        FeatureFlagHelpers.isEnabled(flag, { user, team: { flags: project?.teamFlags } }),
};

export { FeatureFlagHelpers };
